import { render } from "./access_control.html?vue&type=template&id=3e1ac5e8&external"
import script from "./access_control.js?vue&type=script&lang=js&external"
export * from "./access_control.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__